import type ProductImpressionData from '~/types/analytics/marketplace/ProductImpressionData'
import type ProductClickData from '~/types/analytics/marketplace/ProductClickData'
import type ProductViewData from '~/types/analytics/marketplace/ProductViewData'
import type ProductAddedToCartData from '~/types/analytics/marketplace/ProductAddedToCartData'
import type CartViewData from '~/types/analytics/marketplace/CartViewData'
import type BeginCheckoutData from '~/types/analytics/marketplace/BeginCheckoutData'
import type AddPaymentInfoData from '~/types/analytics/marketplace/AddPaymentInfoData'
import type PayButtonClickedData from '~/types/analytics/marketplace/PayButtonClickedData'
import type PaymentSuccessData from '~/types/analytics/checkout/PaymentSuccessData'
import type PaymentDeclinedData from '~/types/analytics/checkout/PaymentDeclinedData'
import type ShowMoreProductsData from '~/types/analytics/marketplace/search/ShowMoreProductsData'
import type ManualSearchData from '~/types/analytics/marketplace/search/ManualSearchData'
import type RefinedSearchData from '~/types/analytics/marketplace/search/RefinedSearchData'
import type QuotePaymentPageViewData from '~/types/analytics/quotes/checkout/QuotePaymentPageViewData'

import type QuotePaymentPageAddedDeliveryInfoData from '~/types/analytics/quotes/checkout/QuotePaymentPageAddedDeliveryInfoData'
import type QuotePaymentPageAddedPaymentInfoData from '~/types/analytics/quotes/checkout/QuotePaymentPageAddedPaymentInfoData'
import type QuotePaymentPagePayButtonClickData from '~/types/analytics/quotes/checkout/QuotePaymentPagePayButtonClickData'
export default abstract class {
  public trackQuoteSubmit(_quoteId: number): void {}

  public trackPageLoad(): void {}

  public trackPageView(_data: Record<string, any>): void {}

  /* Used payment button has been clicked just before redirects */
  public trackQuotePaid(_quoteId: number, _valueInUSD: number): void {}

  public trackMarketplaceProductImpressions(_impressions: ProductImpressionData[]): void {}

  public trackMarketplaceProductClick(_data: ProductClickData): void {}

  public trackMarketplaceProductView(_data: ProductViewData): void {}

  public trackMarketplaceProductAddedToCart(_data: ProductAddedToCartData): void {}

  public trackViewCart(_data: CartViewData): void {}

  public trackBeginCheckout(_data: BeginCheckoutData): void {}

  public trackMarketplaceAddPaymentInfo(_data: AddPaymentInfoData): void {}

  public trackMarketplacePayButtonClick(_data: PayButtonClickedData): void {}

  public trackPaymentSuccessPage(_data: PaymentSuccessData): void {}
  public trackPaymentDeclinedPage(_data: PaymentDeclinedData): void {}

  public trackMarketplaceSearchBarShowMoreProducts(_data: ShowMoreProductsData): void {}

  public trackMarketplaceSearchBarManualSearch(_data: ManualSearchData): void {}

  public trackMarketplaceSearchBarRefinedSearch(_data: RefinedSearchData): void {}

  public trackQuotePaymentPageView(_data: QuotePaymentPageViewData): void {}

  public trackQuotePaymentPageAddedDeliveryInfo(_data: QuotePaymentPageAddedDeliveryInfoData): void {}
  public trackQuotePaymentPageAddedPaymentInfo(_data: QuotePaymentPageAddedPaymentInfoData): void {}
  public trackQuotePaymentPagePayButtonClick(_data: QuotePaymentPagePayButtonClickData): void {}
}
